// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__o6aey","user":"Layout_user__0YKV9","userWrapper":"Layout_userWrapper__7klTv"};